import { PublicSigningRoute as PublicSigning, ValidateDocumentRoute as ValidateDocument, ElectronicSignaturesRoute as ElectronicSignatures } from './features/signatures/LazySignatures';
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './AuthContext';
import GlobalErrorModal from './components/GlobalErrorModal';
import StudentSyncIssueMonitor from './components/StudentSyncIssueMonitor';
import AttendeeSaveErrorMonitor from './components/AttendeeSaveErrorMonitor';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import ExternalForm from './pages/ExternalForm';
import CertificateLookupPublic from './pages/CertificateLookupPublic';
import ActivateAccount from './pages/ActivateAccount';
import { isExclusiveStudent } from './utils/permissions';

function PrivateRoute({ children, studentAllowed = true }) {
  const { token, user, isInitializing } = useAuth();
  if (isInitializing) return null;
  if (!studentAllowed && isExclusiveStudent(user)) return <Navigate to="/dashboard" replace />;
  return token ? children : <Navigate to="/" />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <GlobalErrorModal />
        <StudentSyncIssueMonitor />
        <AttendeeSaveErrorMonitor />
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/assinaturas/assinar" element={<PublicSigning />} />
          <Route path="/assinaturas/validar" element={<ValidateDocument />} />
          <Route path="/assinaturas/verificar" element={<ValidateDocument />} />
          <Route path="/assinaturas" element={<PrivateRoute studentAllowed={false}><ElectronicSignatures /></PrivateRoute>} />
          <Route path="/login" element={<Navigate to="/" replace />} />
          <Route path="/activate" element={<ActivateAccount />} />
          <Route path="/formularios/:token" element={<ExternalForm />} />
          <Route path="/tarefas-externas/:token" element={<ExternalForm />} />
          <Route
            path="/certificados/consulta"
            element={<CertificateLookupPublic />}
          />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route path="*" element={<Navigate to="/dashboard" />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
